module.exports = [{
      plugin: require('/opt/build/repo/blog/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[],"trackingId":"UA-58109113-1","respectDNT":true},
    },{
      plugin: require('/opt/build/repo/blog/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    }]
